// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1ZCzy","unreadBadge":"styles_unreadBadge__1Fjm9","modalContent":"styles_modalContent__3pd8j","modal":"styles_modal__2Esfd"};